// Version 1 „Original neu gestaltet“: Texte für Insights (Übersicht, Referenzen, Listen, Details).
// Verdichtet aus translations.js (insightsPage). Vorgabe Kunde: nur Einträge mit echtem Inhalt.
// Weggelassen: beide Case Studies (Kennzahlen und Projektangaben nicht freigegeben),
// zwei News ohne belegte Grundlage (Kapazitätsausbau, Vertriebspartner Mitteleuropa).
// Artikel mit dem gesperrten Begriff im Slug wurden umbenannt.

const de = {
    common: {
        back: "Alle Insights",
        more: "Weitere Beiträge folgen",
        moreText: "Wir bereiten weitere Inhalte vor. Bis dahin beantworten wir Ihre Fragen gern direkt im Gespräch.",
        moreCta: "Kontakt aufnehmen",
        read: "Lesen",
        minRead: "Min. Lesezeit",
        notFoundTitle: "Dieser Beitrag ist nicht verfügbar.",
        notFoundText: "Alle veröffentlichten Beiträge finden Sie in der Übersicht.",
        soon: "In Vorbereitung",
        types: { "case-studies": "Case Study", articles: "Fachartikel", news: "News" },
    },
    overview: {
        eyebrow: "Parto Insights",
        title: "Wissen. Praxis. Fortschritt.",
        sub: "Typische Projekte, Fachwissen zu industriellen Beständen und Neuigkeiten von Parto.",
        featuredTag: "Empfohlen",
        pathsTitle: "Was Sie hier finden",
        latestTitle: "Neues von Parto",
        paths: [
            { key: "references", name: "Referenzen", title: "Typische Projekte aus der Praxis.", text: "Projekte aus unterschiedlichen Bestandssituationen.", to: "/insights/references", icon: "award" },
            { key: "case-studies", name: "Case Studies", title: "Den Prozess hinter dem Ergebnis verstehen.", text: "Ausgewählte Projekte im Detail.", to: "/insights/case-studies", icon: "layers" },
            { key: "articles", name: "Fachartikel", title: "Perspektiven auf industrielle Bestände.", text: "Leitfäden und Wissen rund um Überbestand, Altbestand und Ersatzteile.", to: "/insights/articles", icon: "book" },
            { key: "news", name: "News", title: "Aktuelles von Parto.", text: "Neuigkeiten zu Parto und seinen Kanälen.", to: "/insights/news", icon: "news" },
        ],
    },
    references: {
        eyebrow: "Referenzen",
        title: "Typische Projekte aus der Praxis.",
        sub: "So bringt Parto industrielle Assets in ganz unterschiedlichen Situationen geordnet zurück in den Markt.",
        projectsTitle: "Typische Projekte",
        projectsText: "Kunden bleiben anonym. Konkrete Projektdetails stellen wir im persönlichen Gespräch vor.",
        capabilities: "Eingesetzt",
        projects: [
            { tag: "Automotive · Altbestand", title: "Altbestand Automatisierungstechnik", text: "Parto erfasste und strukturierte einen über Jahre gewachsenen Altbestand an Automatisierungskomponenten. Freigegebene Teile gingen in einen geordneten Verkauf.", caps: ["Asset-Daten", "Asset Operations", "Marktzugang"], to: "/solutions/obsolete-slow-moving", icon: "cpu" },
            { tag: "Chemie · Ersatzteile", title: "Ersatzteilbestand MRO", text: "Klarheit über einen großen Ersatzteilbestand und eine geordnete Freigabe überflüssiger Teile, ohne die Versorgung zu gefährden.", caps: ["Asset-Daten", "Asset Operations"], to: "/solutions/mro-spare-parts", icon: "wrench" },
            { tag: "Automotive · Werkschließung", title: "Übergang eines Standorts", text: "Parto erfasste und verkaufte einen kompletten Standort, von Werkzeugmaschinen bis zum Ersatzteillager.", caps: ["Asset-Daten", "Asset Operations", "Marktzugang", "Transparenz"], to: "/solutions/plant-closures", icon: "factory" },
            { tag: "Maschinenbau · Überbestand", title: "Überbestand an mehreren Standorten", text: "Parto baute Überbestände an mehreren Standorten geordnet ab, mit einem zentralen Bericht für Finance.", caps: ["Asset Operations", "Marktzugang"], to: "/solutions/surplus-excess", icon: "boxes" },
            { tag: "Industrie · Mehrere Standorte", title: "Ein Prozess für viele Standorte", text: "Mehrere Standorte, unterschiedliche Bestandssituationen, ein einheitlicher Ablauf.", caps: ["Asset-Daten", "Asset Operations", "Transparenz"], to: "/by-role/operations", icon: "network" },
        ],
    },
    lists: {
        "case-studies": {
            eyebrow: "Case Studies",
            title: "Den Prozess hinter dem Ergebnis verstehen.",
            sub: "Ausgewählte Projekte zeigen im Detail, wie Parto komplexe Bestandssituationen von der Ausgangslage bis zum Ergebnis begleitet.",
            soonText: "Unsere ersten Case Studies sind in Vorbereitung. Typische Projekte finden Sie schon jetzt bei den Referenzen.",
            soonLink: { label: "Zu den Referenzen", to: "/insights/references" },
        },
        articles: {
            eyebrow: "Fachartikel",
            title: "Perspektiven auf industrielle Bestände.",
            sub: "Leitfäden und Einordnungen rund um Überbestand, Altbestand, Ersatzteile und den zweiten Lebenszyklus industrieller Assets.",
        },
        news: {
            eyebrow: "News",
            title: "Aktuelles von Parto.",
            sub: "Neuigkeiten zu Parto, seinen Kanälen und seinem Netzwerk.",
        },
    },
    detail: {
        takeaways: "Das Wichtigste in Kürze",
        perspective: "So geht Parto vor",
        related: "Passende Lösung",
        others: "Weitere Fachartikel",
        keyFacts: "Auf einen Blick",
        aboutTitle: "Über Parto",
        aboutText: "Parto ist die Komplettlösung für industrielle Überbestände. Parto übernimmt freigegebene Assets, bereitet Daten auf, lagert, verkauft und wickelt ab, aus einer Hand.",
        pressTitle: "Presseanfragen",
        pressText: "Für Interviews, Unternehmensinformationen und Medienanfragen erreichen Sie uns über das Kontaktformular.",
        pressCta: "Zum Kontakt",
        backList: { articles: "Alle Fachartikel", news: "Alle News", "case-studies": "Alle Case Studies" },
    },
    articles: [
        {
            slug: "second-life-cycle-industrial-assets",
            category: "Zweiter Lebenszyklus",
            kind: "Definition",
            title: "Was bedeutet der zweite Lebenszyklus industrieller Assets?",
            teaser: "Warum er mehr umfasst als den Verkauf gebrauchter Anlagen und an welchen Stellen Unternehmen typischerweise Wert verlieren.",
            lead: "Der zweite Lebenszyklus beschreibt den geordneten Weg, nicht mehr benötigte industrielle Assets wieder in wirtschaftliche Nutzung zu bringen. Dieser Artikel erklärt, was dazu gehört, wie er sich von einer Liquidation unterscheidet und wo der meiste Wert liegen bleibt.",
            takeaways: [
                "Der zweite Lebenszyklus ist ein operativer Prozess, keine reine Verkaufsaufgabe.",
                "Datenqualität und physische Abwicklung entscheiden über den erzielbaren Wert.",
                "Geordneter Verkauf und Liquidation sind nicht dasselbe.",
                "Je früher Assets in einen klaren Prozess kommen, desto besser das Ergebnis.",
            ],
            sections: [
                { heading: "Mehr als ein Verkauf", paragraphs: [
                    "Dazu gehört alles, was nach der Entscheidung passiert, dass ein Asset intern nicht mehr gebraucht wird: Identifikation, Daten, physische Abwicklung, Marktzugang, Verkauf und, wo eine Wiederverwendung nicht sinnvoll ist, das Recycling.",
                    "Der Wert entsteht nicht erst im Moment des Verkaufs. Er entsteht durch die Qualität des Weges, der dorthin führt.",
                ] },
                { heading: "Geordneter Verkauf statt Liquidation", paragraphs: [
                    "Liquidation heißt meist, alles schnell und als Paket abzugeben, oft weit unter dem möglichen Wert. Ein geordneter Weg fragt zuerst, was ein Asset ist, wo Nachfrage besteht und welcher Weg wirtschaftlich am meisten bringt: Wiederverwendung, Weiterverkauf oder Recycling.",
                ] },
                { heading: "Wo Wert verloren geht", paragraphs: [
                    "Die größten Verluste entstehen vor jedem Kontakt mit dem Markt: unvollständige Daten, unbekannter Zustand, fehlende Unterlagen und verschobene Entscheidungen. Jeder Monat ohne klaren Weg senkt den erzielbaren Wert.",
                    "Ein geordneter Prozess setzt genau dort an: klare Freigaben, saubere Daten, physische Kontrolle und Zugang zu passender Nachfrage.",
                ] },
            ],
            perspective: "Parto behandelt den zweiten Lebenszyklus als wiederholbaren Prozess: Freigegebene Assets werden erfasst, strukturiert und auf den wirtschaftlich besten Weg gebracht, mit voller Transparenz über Status und Ergebnis.",
            related: { label: "Überbestand", to: "/solutions/surplus-excess" },
        },
        {
            slug: "obsolete-inventory-management",
            category: "Altbestand",
            kind: "Leitfaden",
            title: "Wie sich industrielle Altbestände steuern lassen",
            teaser: "Wie Altbestände entstehen, welche Kosten sie verursachen und welche Schritte vom Abschreibungsrisiko zum erzielten Wert führen.",
            lead: "Altbestände binden Kapital, Fläche und Aufmerksamkeit, oft über Jahre. Dieser Leitfaden zeigt, wie sie entstehen, was das Liegenlassen kostet und wie ein klarer Prozess aus einem Bilanzproblem einen erzielten Wert macht.",
            takeaways: [
                "Altbestand ist meist ein Problem im Ablauf, nicht nur im Einkauf.",
                "Lagerkosten summieren sich still: Fläche, Lagerhaltung, Verwaltung, Abschreibung.",
                "Nachfrage am Markt gibt es oft auch dann, wenn der interne Bedarf endet.",
                "Ein fester Freigabeprozess schlägt gelegentliche Aufräumaktionen.",
            ],
            sections: [
                { heading: "Wie Altbestände entstehen", paragraphs: [
                    "Abkündigungen, Stilllegungen, Überbestellungen und neue Wartungsstrategien schaffen Bestände, die intern nie wieder genutzt werden. Weil die Verantwortung zwischen Instandhaltung, Einkauf und Finance verteilt ist, bleiben diese Positionen oft jahrelang unberührt.",
                ] },
                { heading: "Was Altbestände wirklich kosten", paragraphs: [
                    "Neben dem Abschreibungsrisiko kostet jede Palette laufend Geld: Fläche, Inventur, Versicherung, Lagerhaltung und Verwaltung. Dazu kommt das Kapital, das an anderer Stelle arbeiten könnte.",
                    "Wer diese Kosten je Gruppe sichtbar macht, entscheidet schneller und besser über eine Freigabe.",
                ] },
                { heading: "Vom Risiko zum erzielten Wert", paragraphs: [
                    "Der Weg führt über fünf Schritte: Positionen ohne Bedarf erkennen, Daten und Zustand prüfen, die Freigabe mit der Technik entscheiden, die Assets für den Markt aufbereiten und über passende Kanäle verkaufen.",
                    "Obsolet heißt nicht wertlos. Industrielle Komponenten finden regelmäßig Nachfrage in anderen Werken, Regionen und Branchen, wenn sie eindeutig identifiziert und erreichbar sind.",
                ] },
            ],
            perspective: "Parto übernimmt genau diesen Prozess: vom Erkennen der Positionen über Daten und Logistik bis zum geordneten Verkauf. So wird aus Altbestand erzielter Wert statt dauerhaftes Risiko.",
            related: { label: "Altbestand und Slow Mover", to: "/solutions/obsolete-slow-moving" },
        },
        {
            slug: "mro-inventory-optimization",
            category: "MRO und Ersatzteile",
            kind: "Leitfaden",
            title: "MRO-Bestände optimieren: ein praktischer Leitfaden",
            teaser: "Warum Ersatzteilbestände schneller wachsen als andere Bestände und wie sie sich verkleinern lassen, ohne die Versorgung zu gefährden.",
            lead: "MRO-Bestände sichern die Versorgung. Aber sie wachsen über Jahre, werden selten bereinigt und binden viel Kapital. Dieser Leitfaden zeigt, wie man sie verkleinert, ohne die Verfügbarkeit zu riskieren.",
            takeaways: [
                "Der Abbau beginnt mit der Kritikalität, nicht mit dem Wert.",
                "Kritische Ersatzteile bleiben, unkritischer Überschuss kann gehen.",
                "Die Datenqualität entscheidet, was sich wirklich verkaufen lässt.",
                "Optimierung ist ein laufender Prozess, kein einmaliges Projekt.",
            ],
            sections: [
                { heading: "Warum MRO-Bestände wachsen", paragraphs: [
                    "Jede Maschinengeneration bringt neue Ersatzteile, die alten bleiben für alle Fälle. Die Instandhaltung stellt zu Recht die Verfügbarkeit über den Bestandswert. So sammelt sich über Jahrzehnte, Standorte und Systemwechsel viel an.",
                ] },
                { heading: "Erst die Kritikalität, dann der Abbau", paragraphs: [
                    "Ein fundierter Abbau beginnt mit der Frage: Welche Teile stoppen die Produktion, wenn sie fehlen? Diese bleiben, egal wie hoch ihr Buchwert ist. Alles andere wird geprüft: Dubletten, Teile stillgelegter Maschinen, überlagertes Verbrauchsmaterial.",
                    "Diese Trennung schützt die Versorgung und schafft einen klar abgegrenzten Bestand, der freigegeben werden kann.",
                ] },
                { heading: "Aus Überschuss wird Wert", paragraphs: [
                    "Freigegebene Ersatzteile haben oft echte Nachfrage, denn andere Werke betreiben dieselben Maschinen. Voraussetzung sind saubere Daten: Hersteller, Teilenummer, Zustand, Unterlagen.",
                ] },
            ],
            perspective: "Parto legt gemeinsam mit der Instandhaltung fest, was bleiben muss, und übernimmt alles, was gehen kann: von Identifikation und Daten bis zu Verkauf und Abwicklung.",
            related: { label: "MRO und Ersatzteile", to: "/solutions/mro-spare-parts" },
        },
        {
            slug: "structured-sale-vs-liquidation",
            category: "Zweiter Lebenszyklus",
            kind: "Vergleich",
            title: "Geordneter Verkauf oder Liquidation: wo liegt der Unterschied?",
            teaser: "Zwei Wege für freigegebene Assets, mit sehr unterschiedlichen Folgen für Erlös, Aufwand und Kontrolle.",
            lead: "Wenn industrielle Assets nicht mehr gebraucht werden, wählen Unternehmen meist zwischen schneller Liquidation und einem geordneten Verkauf. Dieser Vergleich zeigt, wo die Unterschiede liegen und warum sie wirtschaftlich zählen.",
            takeaways: [
                "Liquidation setzt auf Tempo, der geordnete Verkauf auf Erlös.",
                "Saubere Daten und Zugang zu Kanälen machen den Unterschied im Preis.",
                "Beim geordneten Verkauf behalten Sie die Kontrolle über Ablauf und Ergebnis.",
                "Die richtige Wahl hängt von Zeitplan, Art der Assets und Nachfrage ab.",
            ],
            sections: [
                { heading: "Was Liquidation in der Praxis heißt", paragraphs: [
                    "Bei einer Liquidation geht der Bestand als Paket an einen einzigen Käufer oder Kanal. Das ist schnell und kostet intern wenig Aufwand. Der Preis spiegelt aber die Marge des Käufers, nicht den Wert der Assets, und auf das Ergebnis haben Sie kaum Einfluss.",
                ] },
                { heading: "Was der geordnete Verkauf anders macht", paragraphs: [
                    "Hier werden Assets einzeln oder in Gruppen betrachtet: identifiziert, mit Daten und Zustand dokumentiert und dann auf den wirtschaftlich besten Weg gebracht. Das kann direkte Nachfrage sein, ein Händlernetz oder, wo sich Wiederverwendung nicht mehr lohnt, das Recycling.",
                ] },
                { heading: "Wann welcher Weg passt", paragraphs: [
                    "Harte Fristen und einfacher, gleichartiger Bestand können eine Liquidation rechtfertigen. Für gemischte industrielle Assets mit echter Nachfrage lohnt sich fast immer der geordnete Verkauf.",
                    "In der Praxis lassen sich beide Wege kombinieren: schnelle Kanäle für einfache Gruppen, gezielter Verkauf für wertvolle. Der Wert bestimmt den Kanal, nicht umgekehrt.",
                ] },
            ],
            perspective: "Parto bietet beides aus einer Hand: den Verkauf im Auftrag für den höchsten Erlös oder den Sofortankauf über BuyParto, wenn es schnell gehen muss.",
            related: { label: "Operations & Management", to: "/by-role/operations" },
        },
    ],
    news: [
        {
            slug: "hubparto-channel-development",
            category: "Kanäle",
            title: "Parto entwickelt den B2B-Kanal HubParto weiter",
            teaser: "Parto baut den eigenen B2B-Kanal HubParto weiter aus und verbindet industrielle Komponenten gezielt mit professionellen Käufern.",
            lead: "Weiterentwicklung des eigenen B2B-Kanals von Parto.",
            body: [
                "Parto entwickelt HubParto, den eigenen B2B-Kanal, laufend weiter. HubParto verbindet verfügbare industrielle Komponenten mit Unternehmen, die diese Teile für Produktion, Instandhaltung und Reparatur brauchen.",
                "Der Kanal ist Teil des Parto Ökosystems: Parto strukturiert freigegebene Assets zentral und bringt sie dorthin, wo passende Nachfrage besteht.",
            ],
            keyFacts: [
                { k: "Was", v: "Weiterentwicklung von HubParto" },
                { k: "Warum", v: "Direkter Zugang zu industrieller B2B-Nachfrage" },
                { k: "Teil von", v: "Parto Ökosystem" },
            ],
            link: { label: "Zum Ökosystem", to: "/ecosystem" },
        },
    ],
};

const en = {
    common: {
        back: "All insights",
        more: "More articles coming soon",
        moreText: "We are preparing more content. Until then, we are happy to answer your questions directly.",
        moreCta: "Get in touch",
        read: "Read",
        minRead: "min read",
        notFoundTitle: "This article is not available.",
        notFoundText: "You will find all published articles in the overview.",
        soon: "In preparation",
        types: { "case-studies": "Case study", articles: "Article", news: "News" },
    },
    overview: {
        eyebrow: "Parto Insights",
        title: "Knowledge. Practice. Progress.",
        sub: "Typical projects, know-how on industrial inventory and news from Parto.",
        featuredTag: "Featured",
        pathsTitle: "What you will find here",
        latestTitle: "New from Parto",
        paths: [
            { key: "references", name: "References", title: "Typical projects from practice.", text: "Typical projects from different inventory situations.", to: "/insights/references", icon: "award" },
            { key: "case-studies", name: "Case studies", title: "Understand the process behind the result.", text: "Selected projects in detail.", to: "/insights/case-studies", icon: "layers" },
            { key: "articles", name: "Articles", title: "Perspectives on industrial inventory.", text: "Guides and knowledge on surplus, obsolete stock and spare parts.", to: "/insights/articles", icon: "book" },
            { key: "news", name: "News", title: "The latest from Parto.", text: "News about Parto and its channels.", to: "/insights/news", icon: "news" },
        ],
    },
    references: {
        eyebrow: "References",
        title: "Typical projects from practice.",
        sub: "How Parto brings industrial assets back to market in an orderly way, across very different situations.",
        projectsTitle: "Typical projects",
        projectsText: "Customers remain anonymous. We present specific project details in a personal conversation.",
        capabilities: "Used",
        projects: [
            { tag: "Automotive · Obsolete stock", title: "Legacy automation inventory", text: "Parto captured and structured automation components that had built up over years. Released parts went into an orderly sale.", caps: ["Asset Data", "Asset Operations", "Market access"], to: "/solutions/obsolete-slow-moving", icon: "cpu" },
            { tag: "Chemicals · Spare parts", title: "MRO spare parts portfolio", text: "Clarity over a large spare parts inventory and an orderly release of surplus parts without putting supply at risk.", caps: ["Asset Data", "Asset Operations"], to: "/solutions/mro-spare-parts", icon: "wrench" },
            { tag: "Automotive · Plant closure", title: "Site transition", text: "Parto captured and sold a complete site, from machine tools to the spare parts store.", caps: ["Asset Data", "Asset Operations", "Market access", "Transparency"], to: "/solutions/plant-closures", icon: "factory" },
            { tag: "Machinery · Surplus", title: "Surplus across several sites", text: "Parto reduced surplus stock across several sites in an orderly way, with one central report for finance.", caps: ["Asset Operations", "Market access"], to: "/solutions/surplus-excess", icon: "boxes" },
            { tag: "Industrial · Multiple sites", title: "One process for many sites", text: "Several sites, different inventory situations, one consistent process.", caps: ["Asset Data", "Asset Operations", "Transparency"], to: "/by-role/operations", icon: "network" },
        ],
    },
    lists: {
        "case-studies": {
            eyebrow: "Case studies",
            title: "Understand the process behind the result.",
            sub: "Selected projects show in detail how Parto handles complex inventory situations from the starting point to the result.",
            soonText: "Our first case studies are in preparation. You can already find typical projects among the references.",
            soonLink: { label: "Go to references", to: "/insights/references" },
        },
        articles: {
            eyebrow: "Articles",
            title: "Perspectives on industrial inventory.",
            sub: "Guides and context on surplus, obsolete stock, spare parts and the second life cycle of industrial assets.",
        },
        news: {
            eyebrow: "News",
            title: "The latest from Parto.",
            sub: "News about Parto, its channels and its network.",
        },
    },
    detail: {
        takeaways: "Key takeaways",
        perspective: "How Parto approaches this",
        related: "Matching solution",
        others: "More articles",
        keyFacts: "Key facts",
        aboutTitle: "About Parto",
        aboutText: "Parto is the complete solution for industrial surplus inventory. Parto takes over released assets, prepares data, stores, sells and settles, all from a single source.",
        pressTitle: "Press enquiries",
        pressText: "For interviews, company information and media enquiries, please reach us via the contact form.",
        pressCta: "Go to contact",
        backList: { articles: "All articles", news: "All news", "case-studies": "All case studies" },
    },
    articles: [
        {
            slug: "second-life-cycle-industrial-assets",
            category: "Second life cycle",
            kind: "Definition",
            title: "What does the second life cycle of industrial assets mean?",
            teaser: "Why it covers more than selling used equipment, and where companies typically lose value.",
            lead: "The second life cycle describes the orderly path of bringing industrial assets that are no longer needed back into economic use. This article explains what it includes, how it differs from liquidation and where most value is left behind.",
            takeaways: [
                "The second life cycle is an operational process, not just a sales task.",
                "Data quality and handling determine the achievable value.",
                "An orderly sale and a liquidation are not the same.",
                "The earlier assets enter a clear process, the better the result.",
            ],
            sections: [
                { heading: "More than a sale", paragraphs: [
                    "It covers everything that happens after the decision that an asset is no longer needed internally: identification, data, physical handling, market access, sale and, where reuse makes no sense, recycling.",
                    "Value is not created only at the moment of sale. It is created by the quality of the path that leads there.",
                ] },
                { heading: "An orderly sale instead of liquidation", paragraphs: [
                    "Liquidation usually means letting everything go quickly as a package, often far below its potential value. An orderly approach first asks what an asset is, where demand exists and which path brings the most: reuse, resale or recycling.",
                ] },
                { heading: "Where value is lost", paragraphs: [
                    "The biggest losses happen before any contact with the market: incomplete data, unknown condition, missing documents and postponed decisions. Every month without a clear path lowers the achievable value.",
                    "An orderly process addresses exactly these points: clear releases, clean data, physical control and access to matching demand.",
                ] },
            ],
            perspective: "Parto treats the second life cycle as a repeatable process: released assets are captured, structured and sent down the economically best path, with full transparency over status and results.",
            related: { label: "Surplus inventory", to: "/solutions/surplus-excess" },
        },
        {
            slug: "obsolete-inventory-management",
            category: "Obsolete stock",
            kind: "Guide",
            title: "How to manage obsolete industrial inventory",
            teaser: "How obsolete stock builds up, what it costs and which steps lead from write-down risk to realised value.",
            lead: "Obsolete stock ties up capital, space and attention, often for years. This guide shows how it builds up, what leaving it costs and how a clear process turns a balance sheet problem into realised value.",
            takeaways: [
                "Obsolete stock is usually a process problem, not only a purchasing one.",
                "Carrying costs add up quietly: space, handling, administration, write-downs.",
                "Market demand often exists even when internal demand ends.",
                "A fixed release process beats occasional clean-up projects.",
            ],
            sections: [
                { heading: "How obsolete stock builds up", paragraphs: [
                    "Discontinuations, shutdowns, over-ordering and new maintenance strategies create stock that will never be used internally again. Because responsibility is split between maintenance, procurement and finance, these items often stay untouched for years.",
                ] },
                { heading: "What obsolete stock really costs", paragraphs: [
                    "Besides the write-down risk, every pallet costs money: space, stocktaking, insurance, handling and administration. On top of that comes the capital that could be working elsewhere.",
                    "Making these costs visible per group leads to faster and better release decisions.",
                ] },
                { heading: "From risk to realised value", paragraphs: [
                    "The way out has five steps: identify items without demand, check data and condition, decide on release with engineering, prepare the assets for the market and sell through suitable channels.",
                    "Obsolete does not mean worthless. Industrial components regularly find demand in other plants, regions and industries, as long as they are clearly identified and accessible.",
                ] },
            ],
            perspective: "Parto runs exactly this process: from identifying the items through data and handling to an orderly sale. Obsolete stock becomes realised value instead of a lasting risk.",
            related: { label: "Obsolete and slow-moving stock", to: "/solutions/obsolete-slow-moving" },
        },
        {
            slug: "mro-inventory-optimization",
            category: "MRO and spare parts",
            kind: "Guide",
            title: "Optimising MRO inventory: a practical guide",
            teaser: "Why spare parts inventory grows faster than other stock and how to reduce it without putting supply at risk.",
            lead: "MRO inventory secures supply. But it grows over years, is rarely cleaned up and ties up a lot of capital. This guide shows how to reduce it without risking availability.",
            takeaways: [
                "Reduction starts with criticality, not with value.",
                "Critical spare parts stay, non-critical surplus can go.",
                "Data quality decides what can really be sold.",
                "Optimisation is an ongoing process, not a one-off project.",
            ],
            sections: [
                { heading: "Why MRO inventory grows", paragraphs: [
                    "Every machine generation brings new spare parts, while the old ones stay just in case. Maintenance rightly puts availability above inventory value. That is how stock builds up over decades, sites and system migrations.",
                ] },
                { heading: "Criticality first, then reduction", paragraphs: [
                    "A sound reduction starts with one question: which parts stop production if they are missing? These stay, whatever their book value. Everything else is reviewed: duplicates, parts of retired machines, expired consumables.",
                    "This separation protects supply and creates a clearly defined stock that can be released.",
                ] },
                { heading: "Turning surplus into value", paragraphs: [
                    "Released spare parts often meet real demand, because other plants run the same machines. The prerequisite is clean data: manufacturer, part number, condition, documents.",
                ] },
            ],
            perspective: "Parto works with maintenance teams to define what must stay and takes over everything that can go: from identification and data to sale and settlement.",
            related: { label: "MRO and spare parts", to: "/solutions/mro-spare-parts" },
        },
        {
            slug: "structured-sale-vs-liquidation",
            category: "Second life cycle",
            kind: "Comparison",
            title: "Orderly sale or liquidation: what is the difference?",
            teaser: "Two paths for released assets, with very different effects on proceeds, effort and control.",
            lead: "When industrial assets are no longer needed, companies usually choose between fast liquidation and an orderly sale. This comparison shows where the approaches differ and why the difference matters financially.",
            takeaways: [
                "Liquidation optimises for speed, an orderly sale for proceeds.",
                "Clean data and channel access drive the price difference.",
                "With an orderly sale you keep control over process and outcome.",
                "The right choice depends on timeline, asset type and demand.",
            ],
            sections: [
                { heading: "What liquidation means in practice", paragraphs: [
                    "In a liquidation, the stock goes as a package to a single buyer or channel. It is fast and takes little internal effort. But the price reflects the buyer's margin, not the value of the assets, and you have little say in the outcome.",
                ] },
                { heading: "What an orderly sale does differently", paragraphs: [
                    "Here assets are looked at individually or in groups: identified, documented with data and condition, then sent down the economically best path. That can be direct demand, a dealer network or, where reuse no longer pays off, recycling.",
                ] },
                { heading: "When each path fits", paragraphs: [
                    "Hard deadlines and simple, uniform stock can justify liquidation. Mixed industrial assets with real demand almost always justify an orderly sale.",
                    "In practice both can be combined: fast channels for simple groups, targeted sales for valuable ones. Value decides the channel, not the other way round.",
                ] },
            ],
            perspective: "Parto offers both from a single source: the sale on your behalf for the highest proceeds, or the instant purchase through BuyParto when time is short.",
            related: { label: "Operations & Management", to: "/by-role/operations" },
        },
    ],
    news: [
        {
            slug: "hubparto-channel-development",
            category: "Channels",
            title: "Parto continues to develop its B2B channel HubParto",
            teaser: "Parto is expanding its own B2B channel HubParto to connect industrial components with professional buyers.",
            lead: "Further development of Parto's own B2B channel.",
            body: [
                "Parto keeps developing HubParto, its own B2B channel. HubParto connects available industrial components with companies that need these parts for production, maintenance and repair.",
                "The channel is part of the Parto ecosystem: Parto structures released assets centrally and brings them to where matching demand exists.",
            ],
            keyFacts: [
                { k: "What", v: "Further development of HubParto" },
                { k: "Why", v: "Direct access to industrial B2B demand" },
                { k: "Part of", v: "Parto ecosystem" },
            ],
            link: { label: "Go to ecosystem", to: "/ecosystem" },
        },
    ],
};

export default { de, en };
